// extracted by mini-css-extract-plugin
module.exports = {"md":"home-menu-item_md_1IL9c","ios":"home-menu-item_ios_15One","icon":"home-menu-item_icon_1_563"};